import { useCallback, type ChangeEvent } from 'react';
import { formatPhone } from '../../utils/phone';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  placeholder?: string;
  maxLength?: number;
  style?: React.CSSProperties;
}

export function PhoneInput({ value, onChange, id, placeholder = '(555) 123-4567', maxLength = 20, style }: PhoneInputProps) {
  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    onChange(formatPhone(e.target.value));
  }, [onChange]);

  return (
    <input
      type="tel"
      id={id}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={maxLength}
      style={style}
    />
  );
}
